<template>
  <div>
    <h6>Diário Técnico</h6>
    <v-alert v-if="error" type="error" class="mb-0">{{ error }}</v-alert>
    <v-alert v-if="loading" type="info" class="mb-0">
      Carregando registros do diário técnico...
    </v-alert>
    <v-alert
      v-else-if="tecnicianDaily.length === 0"
      type="info"
      class="mb-0"
      text
    >
      Nenhum registro encontrado
    </v-alert>
    <div v-else class="d-flex flex-column gap-2">
      <v-card
        v-for="daily in tecnicianDaily"
        :key="daily.id"
        class="pa-2"
        outlined
        rounded="lg"
      >
        <div class="d-flex align-center gap-2 mb-2">
          <base-avatar :seed="daily.userId" :src="daily.User?.photo" />
          <b>{{ daily.User?.name }}</b>
          <v-spacer></v-spacer>
          {{ daily.createdAt | date("DD/MM/yyyy HH:mm") }}
        </div>
        <p
          v-for="line in daily.body.split('\n')"
          class="mb-0"
          v-text="line"
        ></p>

        <div v-if="daily.attachments.length" class="mt-2">
          <b>Anexos</b>
          <div class="d-flex flex-wrap gap-2 px-1">
            <div v-for="(attachment, index) in daily.attachments" :key="index">
              <v-img
                :src="attachment"
                width="80"
                class="rounded-lg"
                height="80"
                :aspect-ratio="1"
                style="cursor: pointer !important"
                @click="viewImage(attachment)"
              />
            </div>
          </div>
        </div>
      </v-card>
    </div>
    <v-dialog
      v-model="imageDialog.open"
      max-width="900"
      :overlay-opacity="0.95"
      content-class="elevation-0"
    >
      <v-img :src="imageDialog.url" contain max-height="80vh">
        <div
          class="d-flex justify-center gap-2"
          style="position: absolute; bottom: 16px; width: 100%"
        >
          <v-card rounded="pill" elevation="0">
            <v-btn
              rounded
              small
              color="primary"
              @click="downloadImage"
              :loading="imageDialog.status === 'downloading'"
              :disabled="!!imageDialog.status"
            >
              <v-icon left> mdi-download </v-icon>
              Baixar
            </v-btn>
          </v-card>
          <v-card rounded="pill" elevation="0">
            <v-btn
              rounded
              color="primary"
              small
              @click="copyImage"
              :loading="imageDialog.status === 'copying'"
              :disabled="!!imageDialog.status"
            >
              <v-icon left>
                mdi-{{
                  imageDialog.status === "copied" ? "check" : "content-copy"
                }}
              </v-icon>
              {{ imageDialog.status === "copied" ? "Copiado" : "Copiar" }}
            </v-btn>
          </v-card>
          <v-card rounded="pill" elevation="0">
            <v-btn small icon @click="imageDialog.open = false">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-card>
        </div>
      </v-img>
    </v-dialog>
  </div>
</template>

<script>
import PARTY from "@/services/admin/parties";

export default {
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tecnicianDaily: [],
      loading: false,
      error: null,
      imageDialog: { open: false, url: null, status: null },
    };
  },
  mounted() {
    this.getTechnicalDiary();
  },
  methods: {
    async getTechnicalDiary() {
      try {
        this.loading = true;
        const response = await PARTY.getTechnicalDiary(this.party.id);
        this.tecnicianDaily = response.tecnicianDaily;
      } catch (error) {
        this.error = error.message || "Erro ao buscar o diário técnico";
      } finally {
        this.loading = false;
      }
    },
    viewImage(url) {
      this.imageDialog.url = url;
      this.imageDialog.open = true;
    },
    async downloadImage() {
      try {
        this.imageDialog.status = "downloading";

        const response = await fetch(this.imageDialog.url);
        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "attachment";
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      } finally {
        this.imageDialog.status = null;
      }
    },
    async copyImage() {
      try {
        this.imageDialog.status = "copying";
        const response = await fetch(this.imageDialog.url);
        const blob = await response.blob();
        navigator.clipboard.write([
          new ClipboardItem({
            "image/png": blob,
          }),
        ]);
        this.imageDialog.status = "copied";
        setTimeout(() => {
          this.imageDialog.status = null;
        }, 2000);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style></style>
